<template>
  <DxSelectBox v-model:value="localValue"
               :data-source="lookupOptionsStore"
               :placeholder="props.columnName"
               :search-enabled="true"
               :show-clear-button="true"
               @value-changed="handleValueChange"
  />
</template>

<script setup>
  import { ref, computed, watch } from 'vue'
  import { storeToRefs } from 'pinia'
  import { DxSelectBox } from 'devextreme-vue'
  import CustomStore from 'devextreme/data/custom_store'
  import axios from 'axios'
  import { useCabinetStore } from '@/stores/cabinetStore.js'

  const props = defineProps(['value', 'columnName'])

  const emit = defineEmits(['update:value'])

  const cabinetStore = useCabinetStore()
  const { cabinetId } = storeToRefs(cabinetStore)

  const localValue = ref(props.value)

  const createLookupOptionsStore = (cabinetId, columnName) => {
    return new CustomStore({
      load: async (loadOptions) => {
        const params = {
          output_format: 'array',
          search_text: loadOptions.searchValue || '',
          skip: loadOptions.skip || 0,
          take: loadOptions.take || 1000
        }

        const response = await axios.get(`/api/cabinets/${cabinetId}/lookups/${columnName}`, { params })

        return {
          data: response.data.options || [],
          totalCount: response.data.totalCount || 0
        }
      }
    })
  }

  const lookupOptionsStore = computed(() => {
    if (cabinetId.value && props.columnName) {
      return createLookupOptionsStore(cabinetId.value, props.columnName)
    }
    return null
  })

  const handleValueChange = (e) => {
    localValue.value = e.value
    emit('update:value', e.value)
  }

  watch(() => props.value, (newValue) => {
    localValue.value = newValue
  })
</script>

<style scoped lang="scss">
</style>
